// loadUrlOtpLogin.js
'use strict';
import fetch from '../resource/customFetch.js';
import getMeData from '../selector/getMeData.js';
import fetchAccessToken from '../action/fetchAccessToken.js';
import { getHeaders } from '../resource/fetchOptionHeader.js';
import getResourceUrl from '../resource/getResourceUrl.js';
import handleFetchError from '../resource/handleFetchError.js';
import pushToastr from '../action/pushToastr.js';
import handleLoginToken from '../action/handleLoginToken.js';
import setTurnstileToken from '../action/setTurnstileToken.js';
import getOperationData from '../selector/getOperationData.js';
import {
  MERGE_OPERATION_DATA,
  LOGOUT,
  SET_NETWORKING_IDLE,
  SET_NETWORKING_FETCHING,
  SET_NETWORKING_SUCCESS,
  SET_NETWORKING_ERROR,
} from '../ActionTypes.js';

const selectPath = ['login', 'otp', 'auth'];

/**
 * Load url otp login
 * @kind action
 * @param {URL} {url} - action param.
 * @return {Promise} Action promise.
 */
const loadUrlOtpLogin =
  ({ url }) =>
  async (dispatch, getState) => {
    // Should remove after 'android-app' fully deprecated.
    const isFromAndroid = 'android-app' === url.searchParams.get('via');
    if (isFromAndroid) {
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: {
          selectPath: ['login'],
          data: { isFromAndroid: true },
        },
      });
    }

    const otp = url.searchParams.get('otp');
    if (!otp) {
      return { type: '' };
    }
    dispatch({
      type: MERGE_OPERATION_DATA,
      payload: { selectPath: ['login'], data: { otp } },
    });

    const trimedUrl = new URL(url.href);
    trimedUrl.searchParams.delete('android-app');
    trimedUrl.searchParams.delete('otp');
    const trimedPath = `${trimedUrl.pathname}${trimedUrl.search}`;

    const fetchOptions = {
      method: 'POST',
      headers: {
        ...getHeaders(),
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        code: otp,
      }),
    };

    const authUrl = getResourceUrl({ endpoint: '/login/otp' });

    dispatch({ type: SET_NETWORKING_FETCHING, payload: { selectPath } });

    try {
      await dispatch(setTurnstileToken());
      const turnstileToken = getOperationData(
        getState(),
        ['turnstile'],
        'token'
      );
      if (turnstileToken)
        fetchOptions.headers['X-Turnstile-Token'] = turnstileToken;
      // eslint-disable-next-line no-empty
    } catch (e) {}

    let token = undefined;
    try {
      let response = await fetch(authUrl.href, fetchOptions);

      if (!response.ok) {
        response = await handleFetchError({
          response,
          dispatch,
          getState,
          fetchOptions,
          fetchUrl: url,
        });
      }

      dispatch({ type: SET_NETWORKING_SUCCESS, payload: { selectPath } });
      dispatch({ type: LOGOUT });

      const { refresh_token: refreshToken } = await response.json();
      if (refreshToken) {
        await dispatch(fetchAccessToken({ refreshToken }));
        token = getMeData(getState(), 'token');
      }
      if (!token) {
        throw new Error('token_not_found');
      }

      history.replaceState(null, '', trimedPath);

      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: { selectPath: ['login'], data: { otp: null } },
      });
      dispatch(
        pushToastr({
          textKey: 'toast_signup_success',
          durationSec: 3,
        })
      );
      return dispatch(handleLoginToken({ token }));
    } catch (error) {
      history.replaceState(null, '', trimedPath);
      dispatch({
        type: MERGE_OPERATION_DATA,
        payload: { selectPath: ['login'], data: { otp: null } },
      });
      dispatch(
        pushToastr({
          textKey: 'login_via_otp_fail_error_message',
          durationSec: 300,
          color: 'error',
        })
      );
      setTimeout(
        () => dispatch({ type: SET_NETWORKING_IDLE, payload: { selectPath } }),
        1500 // TODO: remote config
      );
      return dispatch({
        type: SET_NETWORKING_ERROR,
        payload: { selectPath, error },
      });
    }
  };

export default loadUrlOtpLogin;
